import { htmlData } from '../htmlData'

/**
 * Where the shell fetches its pilet metadata from.
 *
 * Deploy-time configuration, exactly like the telemetry settings (see
 * `src/htmlData.ts`) — and for this one it is load-bearing rather than convenient.
 *
 * A production release is assembled as an immutable tree under `/r/<version>/`
 * containing the shell bundle, every pilet bundle AND the feed listing them; the
 * release's index.html carries `data-medialib-feed="/r/<version>/pilets.json"`, so
 * the shell only ever loads the pilets it was built and tested against. Going live
 * is one file copy (that index.html to the zone root) and rolling back is the same
 * copy of an older release — neither needs a rebuild, and neither can leave the shell
 * and its pilets on different versions.
 *
 * The fallback is the shared development feed, which is what `just dev` and any
 * un-stamped build resolve to.
 */
export const FEED_URL = htmlData('medialib-feed', 'https://feed.piral.cloud/api/v1/pilet/medialib')
